import { createSlice } from "@reduxjs/toolkit";

export const directorDetailsSlice = createSlice({
  name: "directorDetails",
  initialState: {
    directorDetailsList: [],
    directorDocumentList: [],
    country: "NP",
    perCountry: "NP",
    countryDesc: "NEPAL",
    perCountryDesc: "NEPAL",
    rList: [],
    errors: {},
  },
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
      state.op = "U";
      state.errors.typeError = {};
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload;
      state.errors.firstNameError = {};
      state.pop = "U";
    },
    setMiddleName: (state, action) => {
      state.middleName = action.payload;
      state.errors.middleNameError = {};
      state.pop = "U";
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
      state.errors.lastNameError = {};
      state.pop = "U";
    },
    setDesignation: (state, action) => {
      state.designation = action.payload;
      state.errors.designationError = {};
      state.op = "U";
    },
    setDesignationOthers: (state, action) => {
      state.designationOthers = action.payload;
      state.errors.designationOthersError = {};
      state.op = "U";
    },
    setSpouseFirstName: (state, action) => {
      state.spouseFirstName = action.payload;
      state.errors.spouseFirstNameError = {};
      state.psppop = "U";
    },
    setSpouseMiddleName: (state, action) => {
      state.spouseMiddleName = action.payload;
      state.errors.spouseMiddleNameError = {};
      state.psppop = "U";
    },
    setSpouseLastName: (state, action) => {
      state.spouseLastName = action.payload;
      state.errors.spouseLastNameError = {};
      state.psppop = "U";
    },
    setFatherFirstName: (state, action) => {
      state.fatherFirstName = action.payload;
      state.errors.fatherFirstNameError = {};
      state.pfpop = "U";
    },
    setFatherMiddleName: (state, action) => {
      state.fatherMiddleName = action.payload;
      state.errors.fatherMiddleNameError = {};
      state.pfpop = "U";
    },
    setFatherLastName: (state, action) => {
      state.fatherLastName = action.payload;
      state.errors.fatherLastNameError = {};
      state.pfpop = "U";
    },
    setGrandFatherFirstName: (state, action) => {
      state.grandFatherFirstName = action.payload;
      state.errors.grandFatherFirstNameError = {};
      state.pgfpop = "U";
    },
    setGrandFatherMiddleName: (state, action) => {
      state.grandFatherMiddleName = action.payload;
      state.errors.grandFatherMiddleNameError = {};
      state.pgfpop = "U";
    },
    setGrandFatherLastName: (state, action) => {
      state.grandFatherLastName = action.payload;
      state.errors.grandFatherLastNameError = {};
      state.pgfpop = "U";
    },
    setPanNo: (state, action) => {
      state.panNo = action.payload;
      state.errors.panNoError = {};
      state.pop = "U";
    },
    setIsContactPerson: (state, action) => {
      state.isContactPerson = action.payload;
      state.errors.isContactPersonError = {};
      state.pop = "U";
    },
    setIsDirector: (state, action) => {
      state.isDirector = action.payload;
      state.errors.isDirectorError = {};
      state.pop = "U";
    },
    setIsPrimaryContactPerson: (state, action) => {
      state.isPrimaryContactPerson = action.payload;
      state.errors.isPrimaryContactPerson = {};
      state.pop = "U";
    },
    setSignature: (state, action) => {
      // state.signature = action.payload;
    },
    setPhoto: (state, action) => {
      // state.photo = action.payload;
    },
    setAuthorizedPerson: (state, action) => {
      console.log("ACt", action.payload);
      state.directorDetailsList.forEach((p, i) => {
        console.log(p.index);
        const flag = p.authorizedPerson;
        if ((p.id || p.tempId) === action.payload) {
          p.authorizedPerson = true;
        } else {
          p.authorizedPerson = false;
        }

        if (flag != p.authorizedPerson) {
          p.op = "U";
        }
      });
    },
    setCountry: (state, action) => {
      state.country = action.payload;
      state.op = "U";
      state.errors.countryError = {};
      if (state.hasPermanentAddressSame === true) {
        state.perCountry = action.payload;
        state.errors.perCountryError = {};
        state.pop = "U";
      }
    },
    setCountryDesc: (state, action) => {
      state.countryDesc = action.payload;
      state.op = "U";
    },
    setState: (state, action) => {
      state.state = action.payload;
      state.errors.stateError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perState = action.payload;
        state.errors.perStateError = {};
        state.pop = "U";
      }
    },
    setStateDesc: (state, action) => {
      state.stateDesc = action.payload;
      state.op = "U";
    },
    setDistrict: (state, action) => {
      state.district = action.payload;
      state.errors.districtError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perDistrict = action.payload;
        state.errors.perDistrictError = {};
        state.pop = "U";
      }
    },
    setDistrictDesc: (state, action) => {
      state.districtDesc = action.payload;
      state.op = "U";
    },
    setMunicipality: (state, action) => {
      state.municipality = action.payload;
      state.errors.municipalityError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perMunicipality = action.payload;
        state.errors.perMunicipalityError = {};
        state.pop = "U";
      }
    },
    setMunicipalityDesc: (state, action) => {
      state.municipalityDesc = action.payload;
      state.op = "U";
    },
    setWard: (state, action) => {
      state.ward = action.payload;
      state.wardError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perWard = action.payload;
        state.errors.perWardError = {};
        state.pop = "U";
      }
    },
    setTole: (state, action) => {
      state.tole = action.payload;
      state.errors.toleError = {};
      state.op = "U";

      if (state.hasPermanentAddressSame === true) {
        state.perTole = action.payload;
        state.errors.perToleError = {};
        state.pop = "U";
      }
    },
    setBlockNo: (state, action) => {
      state.blockNo = action.payload;
      state.errors.blockNoError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perBlockNo = action.payload;
        state.errors.perBlockNoError = {};
        state.pop = "U";
      }
    },
    setTelephoneNo: (state, action) => {
      state.telephoneNo = action.payload;
      state.errors.telephoneNoError = {};
      state.op = "U";
      if (state.hasPermanentAddressSame === true) {
        state.perTelephoneNo = action.payload;
        state.errors.perTelephoneNoError = {};
        state.pop = "U";
      }
    },
    setEmailId: (state, action) => {
      state.emailId = action.payload;
      state.errors.emailIdError = {};
      state.paop = "U";
    },
    setMobileNo: (state, action) => {
      state.mobileNo = action.payload;
      state.errors.mobileNoError = {};
      state.paop = "U";
    },
    setHasPermanentAddressSame: (state, action) => {
      state.hasPermanentAddressSame = action.payload;
      if (state.hasPermanentAddressSame === true) {
        state.perCountry = state.country;
        state.perState = state.state;
        state.perDistrict = state.district;
        state.perMunicipality = state.municipality;
        state.perWard = state.ward;
        state.perTole = state.tole;
        state.perBlockNo = state.blockNo;
        state.perTelephoneNo = state.telephoneNo;
        state.ppaop = "U";
      } else {
        state.perCountry = null;
        state.perState = null;
        state.perDistrict = null;
        state.perMunicipality = null;
        state.perWard = null;
        state.perTole = null;
        state.perBlockNo = null;
        state.perTelephoneNo = null;
        state.ppaop = "U";
      }

    },
    setPerCountry: (state, action) => {
      state.perCountry = action.payload;
      state.errors.perCountryError = {};
      state.ppaop = "U";
    },
    setPerCountryDesc: (state, action) => {
      state.countryDesc = action.payload;
    },
    setPerState: (state, action) => {
      state.perState = action.payload;
      state.errors.perStateError = {};
      state.ppaop = "U";
    },
    setPerStateDesc: (state, action) => {
      state.perStateDesc = action.payload;
    },
    setPerDistrict: (state, action) => {
      state.perDistrict = action.payload;
      state.errors.perDistrictError = {};
      state.ppaop = "U";
    },
    setPerDistrictDesc: (state, action) => {
      state.perDistrictDesc = action.payload;
    },
    setPerMunicipality: (state, action) => {
      state.perMunicipality = action.payload;
      state.errors.perMunicipalityError = {};
      state.ppaop = "U";
    },
    setPerMunicipalityDesc: (state, action) => {
      state.perMunicipalityDesc = action.payload;
    },
    setPerWard: (state, action) => {
      state.perWard = action.payload;
      state.errors.perWardError = {};
      state.ppaop = "U";
    },
    setPerTole: (state, action) => {
      state.perTole = action.payload;
      state.errors.perToleError = {};
      state.ppaop = "U";
    },
    setPerBlockNo: (state, action) => {
      state.perBlockNo = action.payload;
      state.errors.perBlockNoError = {};
      state.ppaop = "U";
    },
    setPerTelephoneNo: (state, action) => {
      state.perTelephoneNo = action.payload;
      state.errors.perTelephoneNoError = {};
      state.ppaop = "U";
    },
    setLocationType: (state, action) => {
      state.locationType = action.payload;
    },
    setDirectorTypeOthers: (state, action) => {
      state.directorTypeOthers = action.payload;
      state.errors.directorTypeOthersErro = {};
      state.op = "U";
    },
    setDirectorEditById: (state, action) => {
      const odata = state.directorDetailsList.find(
        (d) => (d.id || d.tempId) === action.payload
      );

      Object.keys(odata)
        .filter(
          (k) =>
            odata.hasOwnProperty(k) &&
            ![
              "directorDetailsList",
              "directorDocumentList",
              "rList",
              "documentList",
              "errors",
            ].includes(k)
        )
        .forEach((k) => (state[k] = odata[k]));

      state.directorId = odata.id || odata.tempId;
    },
    addDirectorDetails: (state, action) => {
      console.log(state, "stae", action);
      const data = {};

      Object.keys(state)
        .filter(
          (k) =>
            state.hasOwnProperty(k) &&
            ![
              "directorDetailsList",
              "directorDocumentList",
              "rList",
              "documentList",
              "directorId",
              "errors",
            ].includes(k)
        )
        .forEach((k) => (data[k] = state[k]));

      data.documentList = state.directorDocumentList;

      data.name = data.firstName + " " + data.middleName + " " + data.lastName;

      if (state.directorId) {
        console.log("hello dir", state.directorId);
        const odata = state.directorDetailsList.find(
          (d) => (d.id || d.tempId) === state.directorId
        );

        Object.keys(data)
          .filter((k) => data.hasOwnProperty(k))
          .forEach((k) => (odata[k] = data[k]));
      } else {
        console.log(
          "hello",
          state.directorDetailsList.map((d) => d.tempId || 0)
        );
        data.tempId =
          Math.max(
            ...[...state.directorDetailsList.map((d) => d.tempId || 0), 0]
          ) + 1;
        if (!state.directorDetailsList.length) {
          data.authorizedPerson = true;
        }
        state.directorDetailsList.push(data);
      }
      state.errors = {};
    },
    addDataInList: (state, action) => {
      state.directorDetailsList[action.payload.rowIndex] = {
        type: action.payload.type,
        firstName: action.payload.firstName,
        middleName: action.payload.middleName,
        lastName: action.payload.lastName,
        designation: action.payload.designation,
        name:
          action.payload.firstName +
          " " +
          action.payload.middleName +
          " " +
          action.payload.lastName,
        ...action.payload,
      };
    },
    removeDirectorDetails: (state, action) => {
      state.directorDetailsList = state.directorDetailsList.filter((d) => {
        if ((d.id || d.tempId) === action.payload && d.id) {
          state.rList.push(d.id);
          return false;
        }

        return true;
      });
    },
    setEditType: (state, action) => {
      state.editType = action.payload;
    },
    setEditFirstName: (state, action) => {
      state.editFirstName = action.payload;
    },
    setEditMiddleName: (state, action) => {
      state.editMiddleName = action.payload;
    },
    setEditLastName: (state, action) => {
      state.editLastName = action.payload;
    },
    setEditDesignation: (state, action) => {
      state.editDesignation = action.payload;
    },
    setEditSpouseFirstName: (state, action) => {
      state.editSpouseFirstName = action.payload;
    },
    setEditSpouseMiddleName: (state, action) => {
      state.editSpouseMiddleName = action.payload;
    },
    setEditSpouseLastName: (state, action) => {
      state.editSpouseLastName = action.payload;
    },

    setEditFatherFirstName: (state, action) => {
      state.editFatherFirstName = action.payload;
    },
    setEditFatherMiddleName: (state, action) => {
      state.editFatherMiddleName = action.payload;
    },
    setEditFatherLastName: (state, action) => {
      state.editFatherLastName = action.payload;
    },
    setEditGrandFatherFirstName: (state, action) => {
      state.editGrandFatherFirstName = action.payload;
    },
    setEditGrandFatherMiddleName: (state, action) => {
      state.editGrandFatherMiddleName = action.payload;
    },
    setEditGrandFatherLastName: (state, action) => {
      state.editGrandFatherLastName = action.payload;
    },
    setEditPanNo: (state, action) => {
      state.editPanNo = action.payload;
    },
    setDirectorDocumentValue: (state, action) => {
      const document = state.directorDocumentList.find(
        (d) => d.documentTypeId === action.payload.code
      );

      if (document) {
        document[action.payload.key] = action.payload.value;
        document.op = "U";
      }
    },
    setDocumentTypeListForDirector: (state, action) => {
      state.directorDocumentList = action.payload
        .filter((d) => d.usedFor === "D" || d.code === "PH")
        .map((d) => ({
          ...(state.directorDocumentList.find((d1) => {
            return d1.documentTypeId === d.code;
          }) || {}),
          documentTypeId: d.code,
          documentTypeDesc: d.descEng,
          documentTypeDescNp: d.descNep,
          type: d.type,
          isBothSided: d.isBothSided,
          ...d
        }));
    },
    setDirectorDocumentListData: (state, action) => {
      console.log("----------------", action.payload);
      state.directorDocumentList = state.directorDocumentList.map((d) => {
        const document =
          action.payload.find((d1) => d1.documentTypeId === d.documentTypeId) ||
          {};

        return { ...d, ...document };
      });

      action.payload
        .filter(
          (d) =>
            !state.directorDocumentList.find(
              (d1) => d1.documentTypeId === d.documentTypeId
            )
        )
        .forEach((d) => {
          state.directorDocumentList.push(d);
        });
    },
    resetDirectorForm: (state, action) => {
      console.log("check of data");
      Object.keys(state)
        .filter(
          (k) =>
            state.hasOwnProperty(k) &&
            ![
              "directorDetailsList",
              "directorDocumentList",
              "rList",
              "documentList",
              "errors",
            ].includes(k)
        )
        .forEach((k) => (state[k] = ""));

      state.directorDocumentList = state.directorDocumentList.map((d) => ({
        documentTypeId: d.documentTypeId,
        documentTypeDesc: d.documentTypeDesc,
        documentTypeDescNp: d.documentTypeDescNp,
        type: d.type,
        isBothSided: d.isBothSided,
        ...d
      }));
    },
    setDirectorDetailListData: (state, action) => {
      state.directorDetailsList = action.payload;
    },
    resetDirectorDetailListData: (state, action) => {
      state.directorDetailsList = state.directorDetailsList.filter((d) => d.id);

      action.payload.forEach((director) => {
        const odirector = state.directorDetailsList.find(
          (d) => d.id == director.id
        );

        if (!odirector) {
          director.op = "N";
          director.pop = "N";
          director.ppaop = "N";
          director.paop = "N";
          director.pgfop = "N";
          director.pfop = "N";
          director.pspop = "N";
          director.tempId = null;
          state.directorDetailsList.push(director);
        } else {
          odirector.id = director.id;
          odirector.pid = director.pid;
          odirector.ppaid = director.ppaid;
          odirector.paid = director.paid;
          odirector.pgfid = director.pgfid;
          odirector.pfid = director.pfid;
          odirector.pspid = director.pspid;
          odirector.pgfpid = director.pgfpid;
          odirector.pfpid = director.pfpid;
          odirector.psppid = director.psppid;
          odirector.op = "N";
          odirector.pop = "N";
          odirector.ppaop = "N";
          odirector.paop = "N";
          odirector.pgfop = "N";
          odirector.pfop = "N";
          odirector.pspop = "N";
          // for update
          odirector.documentList = [
            ...odirector.documentList.filter(
              (d) => d.id && !director.documentList.find((d2) => d2.id == d.id)
            ),
            ...director.documentList.filter((d) => d.op !== "D"),
          ].map((d) => ({ ...d, op: "N" }));
        }
      });
      state.rList = [];
    },
    setTypeError: (state, action) => {
      state.errors.typeError = action.payload;
    },
    setDirFirstNameError: (state, action) => {
      state.errors.firstNameError = {};
      state.errors.firstNameError.message = action.payload.message;
      state.errors.firstNameError.section = action.payload.section;
    },
    setDirLastNameError: (state, action) => {
      state.errors.lastNameError = {};
      state.errors.lastNameError.message = action.payload.message;
      state.errors.lastNameError.section = action.payload.section;
    },
    setDirDesignationError: (state, action) => {
      state.errors.designationError = {};
      state.errors.designationError.message = action.payload.message;
      state.errors.designationError.section = action.payload.section;
    },
    setSpouseFirstNameError: (state, action) => {
      state.errors.spouseFirstNameError = {};
      state.errors.spouseFirstNameError.message = action.payload.message;
      state.errors.spouseFirstNameError.section = action.payload.section;
    },
    setSpouseLastNameError: (state, action) => {
      state.errors.spouseLastNameError = {};
      state.errors.spouseLastNameError.message = action.payload.message;
      state.errors.spouseLastNameError.section = action.payload.section;
    },
    setFatherFirstNameError: (state, action) => {
      state.errors.fatherFirstNameError = {};
      state.errors.fatherFirstNameError.message = action.payload.message;
      state.errors.fatherFirstNameError.section = action.payload.section;
    },

    setFatherLastNameError: (state, action) => {
      state.errors.fatherLastNameError = {};
      state.errors.fatherLastNameError.message = action.payload.message;
      state.errors.fatherLastNameError.section = action.payload.section;
    },
    setGrandFatherFirstNameError: (state, action) => {
      state.errors.grandFatherFirstNameError = {};
      state.errors.grandFatherFirstNameError.message = action.payload.message;
      state.errors.grandFatherFirstNameError.section = action.payload.section;
    },
    setGrandFatherLastNameError: (state, action) => {
      state.errors.grandFatherLastNameError = {};
      state.errors.grandFatherLastNameError.message = action.payload.message;
      state.errors.grandFatherLastNameError.section = action.payload.section;
    },
    setPanNoError: (state, action) => {
      state.errors.panNoError = {};
      state.errors.panNoError.message = action.payload.message;
      state.errors.panNoError.section = action.payload.section;
    },
    setDirCountryError: (state, action) => {
      state.errors.countryError = {};
      state.errors.countryError.message = action.payload.message;
      state.errors.countryError.section = action.payload.section;
    },
    setDirStateError: (state, action) => {
      state.errors.stateError = {};
      state.errors.stateError.message = action.payload.message;
      state.errors.stateError.section = action.payload.section;
    },
    setDirDistrictError: (state, action) => {
      state.errors.districtError = {};
      state.errors.districtError.message = action.payload.message;
      state.errors.districtError.section = action.payload.section;
    },
    setDirMunicipalityError: (state, action) => {
      state.errors.municipalityError = {};
      state.errors.municipalityError.message = action.payload.message;
      state.errors.municipalityError.section = action.payload.section;
    },
    setDirWardError: (state, action) => {
      state.errors.wardError = {};
      state.errors.wardError.message = action.payload.message;
      state.errors.wardError.section = action.payload.section;
    },
    setDirToleError: (state, action) => {
      state.errors.toleError = {};
      state.errors.toleError.message = action.payload.message;
      state.errors.toleError.section = action.payload.section;
    },
    setDirBlockNoError: (state, action) => {
      state.errors.blockNoError = {};
      state.errors.blockNoError.message = action.payload.message;
      state.errors.blockNoError.section = action.payload.section;
    },
    setDirTelephoneNoError: (state, action) => {
      state.errors.telephoneNoError = {};
      state.errors.telephoneNoError.message = action.payload.message;
      state.errors.telephoneNoError.section = action.payload.section;
    },
    setDirEmailIdError: (state, action) => {
      state.errors.emailIdError = {};
      state.errors.emailIdError.message = action.payload.message;
      state.errors.emailIdError.section = action.payload.section;
    },
    setDirMobileNoError: (state, action) => {
      state.errors.mobileNoError = {};
      state.errors.mobileNoError.message = action.payload.message;
      state.errors.mobileNoError.section = action.payload.section;
    },

    setDirPerCountryError: (state, action) => {
      state.errors.perCountryError = {};
      state.errors.perCountryError.message = action.payload.message;
      state.errors.perCountryError.section = action.payload.section;
    },
    setDirPerStateError: (state, action) => {
      state.errors.perStateError = {};
      state.errors.perStateError.message = action.payload.message;
      state.errors.perStateError.section = action.payload.section;
    },
    setDirPerDistrictError: (state, action) => {
      state.errors.perDistrictError = {};
      state.errors.perDistrictError.message = action.payload.message;
      state.errors.perDistrictError.section = action.payload.section;
    },
    setDirPerMunicipalityError: (state, action) => {
      state.errors.perMunicipalityError = {};
      state.errors.perMunicipalityError.message = action.payload.message;
      state.errors.perMunicipalityError.section = action.payload.section;
    },
    setDirPerWardError: (state, action) => {
      state.errors.perWardError = {};
      state.errors.perWardError.message = action.payload.message;
      state.errors.perWardError.section = action.payload.section;
    },
    setDirPerToleError: (state, action) => {
      state.errors.perToleError = {};
      state.errors.perToleError.message = action.payload.message;
      state.errors.perToleError.section = action.payload.section;
    },
    setDirPerBlockNoError: (state, action) => {
      state.errors.perBlockNoError = {};
      state.errors.perBlockNoError.message = action.payload.message;
      state.errors.perBlockNoError.section = action.payload.section;
    },
    setDirPerTelephoneNoError: (state, action) => {
      state.errors.perTelephoneNoError = {};
      state.errors.perTelephoneNoError.message = action.payload.message;
      state.errors.perTelephoneNoError.section = action.payload.section;
    },
    setDirError: (state, action) => {
      state.errors.dirError = {};
      state.errors.dirError.message = action.payload.message;
      state.errors.dirError.section = action.payload.section;
    },
    setIsDirectorError: (state, action) => {
      state.errors.isDirectorError = {};
      state.errors.isDirectorError.message = action.payload.message;
      state.errors.isDirectorError.section = action.payload.section;
    },
    setIsContactPersonError: (state, action) => {
      state.errors.isContactPersonError = {};
      state.errors.isContactPersonError.message = action.payload.message;
      state.errors.isContactPersonError.section = action.payload.section;
    },
    clearDirectorDetailsError: (state) => {
      state.errors = {};
    },
    appendDirectorAddressTempData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => {
          state[key] = action.payload[key];
          state.errors && (state.errors[key + 'Error'] = {});
          switch (key) {
            case 'country':
              state.state = null;
            case 'state':
              state.district = null;
            case 'district':
              state.municipality = null;
            case 'municipality':
              state.ward = null;
          }
          if (state.hasPermanentAddressSame) {
            switch (key) {
              case 'country':
                state.perState = null;
              case 'state':
                state.perDistrict = null;
              case 'district':
                state.perMunicipality = null;
              case 'municipality':
                state.perWard = null;
            }
            state.ppaop = "U";
            state['per' + key.charAt(0).toUpperCase() + key.substring(1)] = action.payload[key];
            state.errors && (state.errors['per' + key.charAt(0).toUpperCase() + key.substring(1) + 'Error'] = {});
          }
        }
      );
      state.paop = "U";
    },
    appendDirectorAddressPermData: (state, action) => {
      Object.keys(action.payload).forEach(
        (key) => {
          state[key] = action.payload[key];
          state.errors && (state.errors[key + 'Error'] = {});
          switch (key) {
            case 'perCountry':
              state.perState = null;
            case 'perState':
              state.perDistrict = null;
            case 'perDistrict':
              state.perMunicipality = null;
            case 'perMunicipality':
              state.perWard = null;
          }
        }
      );
      state.ppaop = "U";
    },
  },
});

export const {
  appendDirectorAddressTempData,
  appendDirectorAddressPermData,
  setDirectorEditById,
  setDirectorDetailListData,
  resetDirectorDetailListData,
  resetDirectorForm,
  setDirectorDocumentListData,
  setDocumentTypeListForDirector,
  setDirectorDocumentValue,
  setType,
  setFirstName,
  setMiddleName,
  setLastName,
  setDesignation,
  setSpouseFirstName,
  setSpouseMiddleName,
  setSpouseLastName,
  setFatherFirstName,
  setFatherMiddleName,
  setFatherLastName,
  setGrandFatherFirstName,
  setGrandFatherMiddleName,
  setGrandFatherLastName,
  setPanNo,
  setSignature,
  setPhoto,
  setAuthorizedPerson,
  addDirectorDetails,
  removeDirectorDetails,
  setEditType,
  setEditFirstName,
  setEditMiddleName,
  setEditLastName,
  setEditDesignation,
  addDataInList,
  setEditFatherFirstName,
  setEditFatherMiddleName,
  setEditFatherLastName,
  setEditGrandFatherFirstName,
  setEditGrandFatherMiddleName,
  setEditGrandFatherLastName,
  setEditSpouseFirstName,
  setEditSpouseMiddleName,
  setEditSpouseLastName,
  setEditPanNo,
  setCountry,
  setState,
  setDistrict,
  setMunicipality,
  setWard,
  setTole,
  setBlockNo,
  setTelephoneNo,
  setEmailId,
  setMobileNo,
  setHasPermanentAddressSame,
  setPerCountry,
  setPerState,
  setPerDistrict,
  setPerMunicipality,
  setPerWard,
  setPerTole,
  setPerBlockNo,
  setPerTelephoneNo,
  setCountryDesc,
  setPerCountryDesc,
  setStateDesc,
  setPerStateDesc,
  setDistrictDesc,
  setPerDistrictDesc,
  setMunicipalityDesc,
  setPerMunicipalityDesc,
  setDirectorTypeOthers,
  setTypeError,
  setDirFirstNameError,
  setDirLastNameError,
  setFatherFirstNameError,
  setFatherLastNameError,
  setGrandFatherFirstNameError,
  setGrandFatherLastNameError,
  setDirDesignationError,
  setPanNoError,
  setSpouseFirstNameError,
  setSpouseLastNameError,
  setDirCountryError,
  setDirStateError,
  setDirDistrictError,
  setDirMunicipalityError,
  setDirWardError,
  setDirToleError,
  setDirBlockNoError,
  setDirTelephoneNoError,
  setDirEmailIdError,
  setDirMobileNoError,
  setDirPerCountryError,
  setDirPerStateError,
  setDirPerDistrictError,
  setDirPerMunicipalityError,
  setDirPerWardError,
  setDirPerToleError,
  setDirPerBlockNoError,
  setDirPerTelephoneNoError,
  clearDirectorDetailsError,
  setDirError,
  setIsContactPerson,
  setIsDirector,
  setDesignationOthers,
  setIsPrimaryContactPerson,
  setIsContactPersonError,
  setIsDirectorError
} = directorDetailsSlice.actions;

export default directorDetailsSlice.reducer;
